export const magicConstants = {
  priceOptionID: "16", //product price option ID
  deliveryInformationId: 6,
  aboutUsInformationId: 4,
  privacyPolicyInformationId: 3,
  helpInformation: 27,
  termsAndConditionsInformation: 5,
  businessInformation: 18,
  helpCMS: 3,
  offerzVoucherId: "4488",
  guestLegit: "gu3stp@ss",
};
